import AbstractModuleFactory from '@core/shared/module-factory';
import { ISendContactWithUsRequirement } from './interfaces/sendcontactwithusrequirement';
import SendContactWithUsRequirementUseCase from './use-cases/SendContactWithUsRequirement';

export class SupportModuleFactory extends AbstractModuleFactory {
  /**
   * Module for handeling send contact request use case
   */
  createSendContactWithUsRequirementUseCase(): ISendContactWithUsRequirement {
    return this.ensureInstance('SendContactWithUsRequirementUseCase', () => new SendContactWithUsRequirementUseCase());
  }

  static new(): SupportModuleFactory {
    return new SupportModuleFactory();
  }
}

export default SupportModuleFactory.new();
